import { Input, Component, OnInit } from '@angular/core';

@Component({
    selector: 'password-info',
    template: require('./password-info.component.html'),
    styles: [require('./password-info.component.css')]
})
export class PasswordInfoComponent implements OnInit {
    private _password: string;
    private strength: number;

    private isMinChars: boolean;
    private isOneBigChar: boolean;
    private isNumberAndChar: boolean;

    @Input() set password(value: string) {
        this._password = value;
        let st: number = 1;
        var regexBig = new RegExp("[A-Z]+"); // Check for uppercase first   
        if (regexBig.test(this._password) == true) {
            this.isOneBigChar = true;
            st++;
        }
        else {
            this.isOneBigChar = false;
        }
            
        var regexNum = new RegExp("[0-9]+"); // Check for uppercase first  
        var regex = new RegExp("[a-z]+"); // Check for uppercase first   
        if ((regexBig.test(this._password) == true || regex.test(this._password) == true) && regexNum.test(this._password) == true) {
            this.isNumberAndChar = true;
            if (regex.test(this._password) == true && regexNum.test(this._password))
                st++;
        }
        else {
            this.isNumberAndChar = false;
        }

        if (this._password.length >= 6) {
            this.isMinChars = true;
            st++;
        }
        else {
            this.isMinChars = false;
            st = 1;
        }
            
        if (this.strength != st)
            this.strength = st;
    }

    get password(): string {
        return this._password;
    }
    
    ngOnInit(): void {
        //this.strength = 1;
        this.isOneBigChar = false;
        this.isMinChars = false;
        this.isNumberAndChar = false;
    }

}